<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { useNavigationStore, type SidebarLinkItem } from '@/stores/navigation-store';
import SidebarLink from '@/components/global/sidebar/SidebarLink.vue';
import SidebarDropdown from "@/components/features/Admin/SidebarDropdown.vue";
import { UserRole } from '@/constants/user';

const navStore = useNavigationStore();

const filteredSidebarLinks = computed(() => {
  return navStore.sidebarLinks.filter((link: SidebarLinkItem) => {
    if (link.meta && link.meta.requiresAdmin) {
      const role = localStorage.getItem('role')
      return Number(role) === UserRole.Admin;
    }
    return true;
  });
});

</script>

<template>
  <aside
    :class="`relative transition-all duration-300 ease-out ${navStore.isSidebarExpanded ? 'w-[305px]' : 'w-28'}`"
  >
    <div class="top-0 sticky h-screen overflow-y-auto w-full bg-white px-5 custom-scrollbar">
      <div class="h-[90px]">
        <RouterLink class="flex items-center h-full" to="/dashboard">
          <img
            src="@/assets/images/logo.png"
            alt="logo"
            :class="`h-8 w-[198px] object-contain transition-all duration-300 ease-out ${navStore.isSidebarExpanded ? 'opacity-100' : 'opacity-0'}`"
          />
          <img
            src="@/assets/images/icon.png"
            alt="icon"
            :class="`h-9 left-1/2 -translate-x-1/2 w-auto object-contain absolute transition-all ease-out duration-300 ${navStore.isSidebarExpanded ? 'opacity-0' : 'opacity-100'}`"
          />
        </RouterLink>
      </div>

      <ul class="flex flex-col gap-y-1.5 py-6">
        <li v-for="link in filteredSidebarLinks" :key="link.label">
          <component
            :is="link.children ? SidebarDropdown : SidebarLink"
            :isExpanded="navStore.isSidebarExpanded"
            v-bind="{ ...link, children: link.children ?? [] }"
          />
        </li>
      </ul>
    </div>
  </aside>
</template>